import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaArrowUp,
} from "react-icons/fa";
import logo from "../Assets/logos/logo.png";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="staffline-footer">

      {/* ===== TOP BORDER ACCENT ===== */}
      <div className="staffline-footer-top-border"></div>

      <div className="container">
        <div className="staffline-footer-grid">

          {/* ===== COLUMN 1: BRAND ===== */}
          <div className="staffline-footer-col staffline-footer-col-brand">
            <Link to="/" className="staffline-footer-logo">
              <img src={logo} alt="StaffLine Transport" />
              <div className="staffline-footer-logo-text">
                <span className="staffline-footer-logo-main">StaffLine</span>
                <span className="staffline-footer-logo-sub">Transport</span>
              </div>
            </Link>

            <p className="staffline-footer-tagline">
              Reliable staff mobility for every worker. Subscribe once, ride
              daily — Monday to Friday, on time, every time.
            </p>

            <div className="staffline-footer-socials">
              <a
                href="https://www.facebook.com/StaffLineTransport"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
              
              <a
                href="https://www.linkedin.com/company/staffline-transport-ltd/home/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
              <a
                href="https://wa.me/233531030191"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>

          {/* ===== COLUMN 2: QUICK LINKS ===== */}
          <div className="staffline-footer-col">
            <h4 className="staffline-footer-heading">Quick Links</h4>
            <ul className="staffline-footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/routes">Routes</Link></li>
              <li><Link to="/subscription">Subscription</Link></li>
              <li><Link to="/portal">Portal</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
            </ul>
          </div>

          {/* ===== COLUMN 3: CONTACT ===== */}
          <div className="staffline-footer-col">
            <h4 className="staffline-footer-heading">Contact Us</h4>
            <ul className="staffline-footer-contact">
              <li>
                <FaPhoneAlt />
                <a href="tel:+233531030191"> +233 53 103 0191</a>
              </li>
              <li>
                <FaEnvelope />
                <a href="mailto:stafflinetransportgh@gmail.com">
                  stafflinetransportgh@gmail.com
                </a>
              </li>
              <li>
                <FaMapMarkerAlt />
                <span>Accra, Greater Accra, Ghana</span>
              </li>
              <li>
                <FaClock />
                <span>Mon – Fri: 8:00 AM – 6:00 PM</span>
              </li>
            </ul>
          </div>

          {/* ===== COLUMN 4: NEWSLETTER ===== */}
          <div className="staffline-footer-col">
            <h4 className="staffline-footer-heading">Stay Updated</h4>
            <p className="staffline-footer-newsletter-text">
              Get route updates, new hubs, and company news delivered to your
              inbox.
            </p>
            <form
              className="staffline-footer-form"
              onSubmit={(e) => e.preventDefault()}
            >
              <input
                type="email"
                placeholder="Your email address"
                aria-label="Email address"
                required
              />
              <button type="submit">Subscribe</button>
            </form>
            <p className="staffline-footer-newsletter-note">
              We respect your privacy. Unsubscribe anytime.
            </p>
          </div>

        </div>
      </div>

      {/* ===== BOTTOM BAR ===== */}
      <div className="staffline-footer-bottom">
        <div className="container staffline-footer-bottom-inner">
          <p className="staffline-footer-copyright">
            © {currentYear} StaffLine Transport Ltd. All rights reserved.
          </p>

          <div className="staffline-footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="staffline-footer-legal-dot">•</span>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>

      {/* ===== BACK TO TOP BUTTON ===== */}
      <button
        className="staffline-footer-backtotop"
        onClick={scrollToTop}
        aria-label="Back to top"
      >
        <FaArrowUp />
      </button>

    </footer>
  );
};

export default Footer;